module.exports = __webpack_public_path__ + "img/logo.5c4ffbe5.png";